export default __webpack_public_path__ + "968a9c8c6572dc01fd55744e01527fe9.png";